import type { Fields } from './types';

export const MAX_LETTER_COUNT = 1000;

export const DEFAULT_VALUES: Fields = {
  question: '',
};

export enum FieldsNames {
  Question = 'question',
}
